//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import {  getCurrentUser , updatePassword  } from "aws-amplify/auth";
import { flatMap, map, filter, hasIn } from 'lodash';
//  -- Actions ------------------------
import * as UsersActions from './actions';

//  -- Lib ----------------------------
import { authHelper } from 'utils/lib/authHelper';
import { handleCreateUserClass } from 'store/userClasses/thunks';
import { handleUpdateClass } from 'store/classes/thunks';
import * as ChatAction  from "../chat/actions"
import { logToSentry } from "utils/networkErrorUtils";
import { apis } from 'utils/lib/apis';
import { handleAwsLogin } from "utils/lib/auth";
import * as OrganizationActions from 'store/organizations/actions';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create user --------------------
export const handleCreateUser = (data, fromReg) => async (dispatch) => {
    await dispatch(UsersActions.createUser());
    try {
        const created_user_response = await apis.post('usersRDS', `/create_user`, {
            body: {
                ...data.user,
                username: data.auth.username,
                password: data.auth.password,
            }
        });
        if (created_user_response && created_user_response.success) {
            if (fromReg) {
                const authData = authHelper(data.auth);
                await handleAwsLogin(authData);
            }
            if (created_user_response.data) {
                await dispatch(UsersActions.createUserSuccess(created_user_response.data));
                if (hasIn(data, "userBooks.books_group") && data.userBooks.books_group.length > 0) {
                    try {
                        data.userBooks.userId = created_user_response.data.id;
                        await apis.post('userBooksRDS', `/userBooks`, {
                            body: data.userBooks
                        });
                    } catch (error) {
                        console.log(error, " data.userBooks");
                    }

                }
            }
            return created_user_response.data;
        } else {
            return created_user_response
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        await dispatch(UsersActions.createUserFail(error));
        return ({ error: true, message: error.message, errorDesctiption: error });
    }
};

//  -- Delete user --------------------
export const handleDeleteUser = (userID, username) => async (dispatch) => {
    await dispatch(UsersActions.deleteUser());

    try {
        const user = await apis.del('usersRDS', `/users/${userID}?username=${username}`);
        await dispatch(UsersActions.deleteUserSuccess(user));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        await dispatch(UsersActions.deleteUserFail(error));
    }
};
export const handleDeleteUserData = (userId, username, orgId, classId) => async (dispatch) => {
    await dispatch(UsersActions.deleteUser());

    try {
        await apis.post('usersRDS', `/usersData`, {
            body: {
                userId,
                username,
                orgId,
                classId
            }
        });
        await dispatch(UsersActions.deleteUserSuccess({ id: userId }));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        await dispatch(UsersActions.deleteUserFail(error));
    }
};

function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
        key: params.get('key') || null,
        role: params.get('role') || null
    };
}
//  -- Get user -----------------------
export const handleGetUser = (userID) => async (dispatch) => {
    await dispatch(UsersActions.getUser());

    try {
        const user = await apis.get('usersRDS', `/users/${userID}`);
        const login_data = getUrlParams()
        if(login_data.key&&login_data.role){
            if(login_data.role=='placement_admin'){
                sessionStorage.setItem('act_as_user', 'placement_admin');
                user.role = 'placement_admin'
            }
        }
        await dispatch(UsersActions.getUserSuccess(user));
        return user;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in get user operation',
                error,
                module: 'USERS',
                operation: 'GET_USER'
            });
        }
        await dispatch(UsersActions.getUserFail(error));
    }
};
export const handleGetUserByUsername = (id, username) => async (dispatch) => {
    await dispatch(UsersActions.getUser());

    try {
        const info = await apis.post('usersRDS', `/get_user_info`, {
            body: {
                id,
                username
            }
        });
        if (info && info.success) {
            const { user, organization, classes } = info.data || {};
            const login_data = getUrlParams()
            if (user) {
                if (login_data.key && login_data.role) {
                    if (login_data.role == 'placement_admin') {
                        sessionStorage.setItem('act_as_user', 'placement_admin');
                        user.role = 'placement_admin'
                    }
                }
                await dispatch(UsersActions.getUserSuccess(user));
            }
            if (organization && organization.id) {
                sessionStorage.setItem('activeSchoolId', organization.id);
                sessionStorage.setItem('activeDistrictId', organization.parentId);
                await dispatch(OrganizationActions.getOrganizationSuccess(organization));
            }
            return ({
                user,
                organization,
                classes,
                error: false,
            })
        }

        return { user: null, organization: null, classes: null, error: true, message: info?.message || "Error in get user operation" };
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in get user operation',
                error,
                module: 'USERS',
                operation: 'GET_USER'
            });
        }
        await dispatch(UsersActions.getUserFail(error));
        return { user: null, organization: null, error: error, message: error.message };
    }
};

//  -- Get All user -----------------------

//  -- List organization users --------
export const handleListOrgUsers = (orgs) => async (dispatch) => {
    await dispatch(UsersActions.listOrgUsers());


    try {
        const orgUser = await apis.post('usersRDS', `/usersByOrgsWithBooks`, {
            body: orgs.map(x => (`'${x.id}'`))
        });
        let userData = []
        if (Array.isArray(orgUser)) {
            userData = orgUser;
        }
        await dispatch(UsersActions.listOrgUsersSuccess(userData));
        return userData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in list org users operation',
                error,
                module: 'USERS',
                operation: 'LIST_ORG_USERS'
            });
        }
        await dispatch(UsersActions.listOrgUsersFail(error));
    }
};
export const handleListDistUsers = (orgId) => async (dispatch) => {
    await dispatch(UsersActions.listOrgUsers());
    try {
        const numberOfUsers = await apis.get('usersRDS', `/districtUserLength/${orgId}`);
        if (numberOfUsers && numberOfUsers.length) {
            const userarr = Array.apply(0, new Array(Math.floor(numberOfUsers.length / 1000) + 1)).map((k, i) => i)
            const allUsers = await Promise.allSettled(map(userarr, async k => {
                return apis.get('usersRDS', `/listDistrictUserLimit/${orgId}/${(k * 1000)}/1000`);
            })
            ).then(v => filter(v, ["status", "fulfilled"]).map(k => k.value))
            const usersRds = flatMap(allUsers);
            await dispatch(UsersActions.listOrgUsersSuccess(usersRds));
            return usersRds;
        } else {

            const orgUser = await apis.get('usersRDS', `/userByDistrict/${orgId}`);
            let userData = []
            if (Array.isArray(orgUser)) {
                userData = orgUser;
            }
            await dispatch(UsersActions.listOrgUsersSuccess(userData));
            return userData;
        }

    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in list org users operation',
                error,
                module: 'USERS',
                operation: 'LIST_ORG_USERS'
            });
        }
        await dispatch(UsersActions.listOrgUsersFail(error));
    }
};

export const handleListDistTeacher = (orgId) => async (dispatch) => {
    await dispatch(UsersActions.listAllTeacherUsers());
    try {
        const numberOfTeachers = await apis.get('usersRDS', `/districtUsersLength/${orgId}`)
        if (numberOfTeachers && numberOfTeachers.length) {
            const userarr = Array.apply(0, new Array(Math.floor(numberOfTeachers.length / 1000) + 1)).map((k, i) => i)
            const allUsers = await Promise.allSettled(map(userarr, async k => {
                return apis.get('usersRDS', `/listDistrictUsersLimit/${orgId}/${(k * 1000)}/1000`);
            })
            ).then(v => filter(v, ["status", "fulfilled"]).map(k => k.value))
            const usersRds = flatMap(allUsers);
            await dispatch(UsersActions.listAllTeacherUsersSuccess(usersRds));
            return usersRds;
        } else {
            return [];
        }

    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in list org users operation',
                error,
                module: 'USERS',
                operation: 'LIST_ORG_USERS'
            });
        }
        await dispatch(UsersActions.listAllTeacherUsersFail(error));
    }
};





export const handleListDistStudent = (orgId) => async (dispatch) => {
  await dispatch(UsersActions.listAllStudentsUsers());
  try {
    const numberOfTeachers = await apis.get(
      "usersRDS",
      `/districtStudentLength/${orgId}`
    );
    if (numberOfTeachers && numberOfTeachers.length) {
      const userarr = Array.apply(
        0,
        new Array(Math.floor(numberOfTeachers.length / 1000) + 1)
      ).map((k, i) => i);
      const allUsers = await Promise.allSettled(
        map(userarr, async (k) => {
          return apis.get(
            "organizationsRDS",
            `/list_org_student/${orgId}/1000/${k * 1000}`
          );
        })
        //   /listDistrictStudent/{id}/{offset}/{limit}
      ).then((v) => filter(v, ["status", "fulfilled"]).map((k) => k.value));
      const usersRds = flatMap(allUsers);
        await dispatch(UsersActions.listAllStudentsUsersSuccess(usersRds));
      return usersRds;
    } else {
      return [];
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
          message: 'Error in list org users operation',
          error,
          module: 'USERS',
          operation: 'LIST_ORG_USERS'
      });
    }
    await dispatch(UsersActions.listAllStudentsUsersFail(error));
  }
};





//  -- Username check -----------------
export const handleCheckUsername = (username) => async (dispatch) => {
    await dispatch(UsersActions.listOrgUsers());
    if (!username) return;
    try {
        const userRDS = await apis.get('usersRDS', `/userByUsername/${username}`);
        if (typeof userRDS == "object") {
            if (userRDS.error) {
                return false;
            } else {
                return userRDS;
            }
        } else {
            return false;
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in list org users operation',
                error,
                module: 'USERS',
                operation: 'LIST_ORG_USERS'
            });
        }
        await dispatch(UsersActions.listOrgUsersFail(error));
    }
};

//  -- Register student --------------------
export const handleRegisterStudent = (userData, booksUser, classData, updateClass, fromReg) => async (dispatch) => {
    await dispatch(UsersActions.registerStudent());

    try {
        const cData = classData[0];
        const createData = {
            auth: {
                username: userData.username.trim(),
                password: userData.password.trim()
            },
            user: {
                orgId: userData.orgId,
                firstName: userData.firstName.trim(),
                lastName: userData.lastName.trim(),
                grade: userData.grade.trim(),
                role: 'student',
            },
            userBooks: booksUser
        };

        if (updateClass) {
            const newCount = cData.studentCount + 1;
            const data = {
                ...cData,
                studentCount: newCount,
                maxCount: cData.maxCount ? (cData.maxCount < newCount ? newCount : cData.maxCount) : newCount
            };

            await dispatch(handleUpdateClass(cData.id, data));
        }

        const newUser = await dispatch(handleCreateUser(createData, fromReg));
        if (!newUser.error) {
            dispatch(handleCreateUserClass({ userId: newUser.userId, classId: cData.id }))
            await dispatch(UsersActions.registerStudentSuccess({ ...createData.user, username: createData.auth.username, id: newUser.userId }));
        }
        return newUser;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        await dispatch(UsersActions.registerStudentFail(error));
        return ({ error: true, message: error.message, errorDesctiption: error });
    }
};

//  -- Update user --------------------
export const handleUpdateUser = (userID, data, booksUser, userBookId) => async (dispatch) => {
    await dispatch(UsersActions.updateUser());

    try {
        const user = await apis.put('usersRDS', `/users/${userID}`, {
            body: { ...data }
        });
        if (booksUser && booksUser.books_group && booksUser.books_group.length > 0) {
            booksUser.userId = userID;
            if (userBookId) {
                await apis.put('userBooksRDS', `/userBooks/${userBookId}`, {
                    body: booksUser
                });
            } else {
                await apis.post('userBooksRDS', `/userBooks`, {
                    body: booksUser
                });
            }
        }

        await dispatch(UsersActions.updateUserSuccess({ id: user.id, data: user }));
        return user;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        await dispatch(UsersActions.updateUserFail(error));
    }
};

//  -- Update New User --------------------


// -- Create Student With Class ----------------
export const handleAddStudentWithClass = (data) => async (dispatch) => {
    // await dispatch(UsersActions.userPasswordChange());

    try {
        const addStudent = await apis.post('usersRDS', `/addStudentToClass`, {
            body: data
        });
        // await dispatch(UsersActions.userPasswordChangeSuccess(addStudent));
        // console.log('data', data);
        return addStudent;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
      dispatch(UsersActions.userPasswordChangeFail(error));
    return { error: true, message: error.message, errorDesctiption: error };
    }
}

//  -- Change User Password without old password ---------------------
export const handleForcePasswordChange = (data) => async (dispatch) => {
    await dispatch(UsersActions.userPasswordChange());

    try {
        const updatePasswordResponse = await apis.put('usersRDS', `/updatePassword`, {
            body: { ...data }
        });
        await dispatch(UsersActions.userPasswordChangeSuccess(updatePasswordResponse));
        return updatePasswordResponse;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        return await dispatch(UsersActions.userPasswordChangeFail(error));
    }
}

//  -- Change User Password ---------------------
export const handlePasswordChange = (data) => async (dispatch) => {
    await dispatch(UsersActions.userPasswordChange());

    try {
        const user = await getCurrentUser();
        await updatePassword(
            {
                oldPassword: data.currentPassword,
                newPassword: data.newPassword
            }
        );
        await dispatch(handleUpdatePassword({ username: user.username, password: data.newPassword }));
        await dispatch(UsersActions.userPasswordChangeSuccess());
        return 'SUCCESS'; 
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user operation',
                error,
                module: 'USERS',
                operation: 'PASSWORD_CHANGE'
            });
        }
        console.log('error', error);
        
        return await dispatch(UsersActions.userPasswordChangeFail(error));
    }
}

const handleUpdatePassword = (data) => async (dispatch) => {
    try {
        await apis.put('usersRDS', `/updateUserPassword`, {
            body: { ...data }
        });
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        console.log(error, "ee");
    }

}

export const getUserBySchoologyId = async (uid) => {
    try {
        return await apis.get("usersRDS", `/schoology/${uid}`, {});
    } catch (error) {
        return ({ error })
    }
}



export const getUserById = async (id) => {
    try {
        return await apis.get("usersRDS", `/userById/${id}`)
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        return []
    }
}


export const handleEnableDiableUser = (userId, status) => async (dispatch) => {
    if (userId) {
        try {
            const enableUser = await apis.put("usersRDS", "/enableUserById", {
                body: {
                    status: status,
                    userId: userId
                }
            })
            if(enableUser&&enableUser.id){
                await dispatch(UsersActions.userEnableSuccess(enableUser))
            }
            return enableUser;
        } catch (error) {
            if (error && error.message != "Network Error") {
                logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
            }
            return await dispatch(UsersActions.userEnableFail(error));
        }
    }
}


export const getUsersCount = () => async (dispatch) => {
    try {
        const usersCount = await apis.get('usersRDS', `/getUsersCount`);
        if (usersCount) {
            await dispatch(UsersActions.listAllStudentUsersSuccess(usersCount));
        }
        return usersCount;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        await dispatch(UsersActions.listAllStudentUsersFail(error));
    }
}



export const handleListSuperAdmins = () => async (dispatch) => {
    await dispatch(UsersActions.listAllUsers());
    try {
        const users = await apis.get('usersRDS', '/listUsersByRole/owe_admin');
        if (users && Array.isArray(users)) {
            await dispatch(UsersActions.listAllUsersSuccess(users));
            return users;
        }
        await dispatch(UsersActions.listAllUsersSuccess([]));
        return [];
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in list super admins operation',
                error,
                module: 'USERS',
                operation: 'LIST_SUPER_ADMINS'
            });
        }
        await dispatch(UsersActions.listAllUsersFail(error));
        return [];
    }
};

export const handleSearchStudents = async (orgId, username) => {
    try {
        const usersCount = await apis.get('usersRDS', `/searchStudents/${orgId}/${username}`);
        if (usersCount) {
            // await dispatch(UsersActions.listAllStudentUsersSuccess(usersCount));

        }
        return usersCount;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        // await dispatch(UsersActions.listAllStudentUsersFail(error));
    }
}
export const handleUpdateUserConfig =  (user_id, config) => async (dispatch) => {
    try {
        const usersCount = await apis.put('usersRDS', `/update_user_config`,{
            body:{
                user_id,
                config
            }
        });
        return usersCount;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        return null
    }
}
export const handlefetchUserProfileConfig = (user_id) => async (dispatch) => {
    try {
        const config = await apis.post('usersRDS', `/get_profile_config`, {
            body: {
                user_id
            }
        });
        if (config) {
            dispatch(UsersActions.setUserProfileConfig(config));
        }
        return config;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
    }
}
export const handleupdateserProfileConfig = (user_id, config) => async (dispatch) => {
    try {
        const configdata = await apis.put('usersRDS', `/update_user_config`, {
            body: {
                user_id,
                config
            }
        });
        if (configdata && configdata.profile_config) {
            dispatch(UsersActions.setUserProfileConfig(configdata.profile_config));
            if (configdata.chat_config) {
                dispatch(ChatAction.updateChatUserConfig(configdata.chat_config))
            }
          return configdata;
        }
       return { };
    } catch (error) {
        logToSentry({
            message: 'Error in user data operation',
            error,
            module: 'USERS',
            operation: 'PROFILE_CONFIG',
            tags: { user_id }
        });
       return null
    }
}

// --- get district teacher ---------

export const handleGetDistrictTeacher = (id, userId) => async (dispatch) => {
    if (!id) return;
    try {
        const teacherRDS = await apis.get('usersRDS', `/listDistrictAllTeacher/${id}`);
        if (typeof teacherRDS == "object") {
            if (teacherRDS.error) {
                return false;
            } else {
                const filteredTeacherRDS = teacherRDS?.filter((obj) => obj.id !== userId)
                await dispatch(UsersActions.list_all_district_teacher(filteredTeacherRDS));
                return filteredTeacherRDS;
            }
        } else {
            return false;
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
    }
};

// --- get assignment count for student data ---------
export const handleGetStudentAssignmentCount = (class_id) => async (dispatch) => {
    if (!class_id) return;
    try {
        const teacherRDS = await apis.post('usersRDS', `/StudentDataStats`, {
            body: {
                class_id
            }
        });
        return teacherRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
    }
};

export const handleUpateUserSubRole = ({userId, user_sub_roles}) => async (dispatch) => {
    if (userId) {
        try {
            const enableUser = await apis.put("usersRDS", "/updateUserSubRole", {
                body: {
                    user_sub_roles: user_sub_roles,
                    userId: userId
                }
            })
            if(enableUser&&enableUser.id){
                await dispatch(UsersActions.userEnableSuccess(enableUser))
            }
            return enableUser;
        } catch (error) {
            if (error && error.message != "Network Error") {
                logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
            }
            return await dispatch(UsersActions.userEnableFail(error));
        }
    }
}
export const handleSetClassAiConfigEnabled = (class_id) => async (dispatch) => {
    try {
        const response = await apis.post('userPreferenceRDS', `/get_ai_config_class_teacher`, {
            body: {
                class_id
            }
        });
        if (response && response.success && response.data) {
            const ai_enabled = response.data.ai_enabled;
            dispatch(UsersActions.set_class_ai_config_enabled(ai_enabled));
            return ai_enabled;
        } else {
            dispatch(UsersActions.set_class_ai_config_enabled(true));
            return true;
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in AI config enabled operation',
                error,
                module: 'USERS',
                operation: 'AI_CONFIG'
            });
        }
        dispatch(UsersActions.set_class_ai_config_enabled(true));
        return true;
    }
}

export const handleCheckUserExist = (email) => async (dispatch) => {
    try {
        const response = await apis.get("usersRDS", `/checkIsUserExist/${email}`);
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in user data operation',
                error,
                module: 'USERS',
                operation: 'CREATE_USER'
            });
        }
        return null;
    }
}